import * as CSS from "../utils/css"
import { RenderTarget } from "../../render/types/RenderEnvironment"

const componentCSSRules = `
[data-framer-component-type] {
    position: absolute;
}
`

const textCSSRules = `
[data-framer-component-type="Text"] {
    cursor: default;
}
`

const stackCSSRules = `
[data-framer-component-type="Stack"] > *,
[data-framer-component-type="Stack"] > [data-framer-component-type],
[data-framer-stack-gap] > *,
[data-framer-stack-gap] > [data-framer-component-type] {
    position: relative;
}

[data-framer-stack-gap] > * {
    margin-top: calc(var(--stack-gap-y) / 2);
    margin-bottom: calc(var(--stack-gap-y) / 2);
    margin-right: calc(var(--stack-gap-x) / 2);
    margin-left: calc(var(--stack-gap-x) / 2);
}

/* This should take the language direction into account */
[data-framer-stack-direction-reverse="false"]
[data-framer-stack-gap]
> *:first-child,
[data-framer-stack-direction-reverse="true"]
[data-framer-stack-gap]
> *:last-child {
    margin-top: 0;
    margin-left: 0;
}

/* This should take the language direction into account */
[data-framer-stack-direction-reverse="false"]
[data-framer-stack-gap]
> *:last-child,
[data-framer-stack-direction-reverse="true"]
[data-framer-stack-gap]
> *:first-child {
    margin-right: 0;
    margin-bottom: 0;
}
`
const combinedCSSRules = `
${componentCSSRules}
${textCSSRules}
${stackCSSRules}
`

/**
 * Add propagation-blocking if we're not on the canvas. If we add this while on the canvas,
 * strange behaviour can appear in the Component panel, with the drag event being blocked.
 */
const frameCSSRules = () => {
    const isCanvas = RenderTarget.current() === RenderTarget.canvas
    return !isCanvas ? ` [data-framer-component-type="Frame"] * { pointer-events: auto; } ` : ``
}

export const injectComponentCSSRules = () => {
    CSS.add(combinedCSSRules)
    CSS.add(frameCSSRules())
}
